/** 生成器语言默认文案的准备状态；不属于章节 AI 任务。 */
import { z } from 'zod';
import { LanguageCodeSchema } from './system-config';

export const LandingLocaleCopySchema = z
  .record(z.string().regex(/^[a-z][a-z0-9_]{0,63}$/), z.string().trim().min(1).max(2000))
  .refine((copy) => Object.keys(copy).length > 0 && Object.keys(copy).length <= 64);
export type LandingLocaleCopy = z.infer<typeof LandingLocaleCopySchema>;
export const LandingCopyProvisioningSchema = z.object({
  language: LanguageCodeSchema,
  status: z.enum(['pending', 'processing', 'failed', 'ready']),
  reason: z.string().nullable(),
  next_retry_at: z.string().nullable(),
});
export type LandingCopyProvisioning = z.infer<typeof LandingCopyProvisioningSchema>;
